/* Solutions.js */

"use strict";
const Registrations = require("./RegistrationNamespaces");
module.exports = {
    ModelEditor: {
        def: require("./solutions/Classic"),
        namespace: Registrations.CLASSIC_SOLUTION,
    },
    WorkflowExplorer: {
        def: require("./solutions/WorkflowExplorer"),
        namespace: Registrations.WORKFLOW_EXPLORER,
    },
    /****************************/
    /* UTILITY SOLUTIONS        */
    /****************************/

    ConfigDrift: {
        def: require("./solutions/utilities/ConfigDrift"),
        namespace: Registrations.CD_UTILITY_SOLUTION,
    },
    DataExport: {
        def: require("./solutions/utilities/DataExport"),
        namespace: Registrations.DATA_EXPORT_UTILITY_SOLUTION,
    },
    OsManager: {
        def: require("./solutions/utilities/OsManager"),
        namespace: Registrations.OS_MANAGER_UTILITY_SOLUTION,
    },

    /****************************/
    /* ADMINISTRATION SOLUTIONS */
    /****************************/

    Dashboard: {
        def: require("./solutions/administration/Dashboard"),
        namespace: Registrations.DASHBOARD_ADMINISTRATION_SOLUTION,
    },
    DeviceManager: {
        def: require("./solutions/administration/DeviceManager"),
        namespace: Registrations.DEVICE_MANAGER_ADMINISTRATION_SOLUTION,
    },
    FileServer: {
        def: require("./solutions/administration/FileServer"),
        namespace: Registrations.FILE_SERVER_ADMINISTRATION_SOLUTION,
    },
    WorkTrig: {
        def: require("./solutions/administration/WorkTriggers"),
        namespace: Registrations.WORK_TRIG_ADMINISTRATION_SOLUTION,
    },
    Settings: {
        def: require("./solutions/administration/SystemSettings"),
        namespace: Registrations.SETTINGS_ADMINISTRATION_SOLUTION,
    },
    PackageManagement: {
        def: require("./solutions/administration/SolutionsManagement"),
        namespace: Registrations.PACKAGE_ADMINISTRATION_SOLUTION,
    },
    DataExplorer: {
        def: require("./solutions/administration/DataExplorer"),
        namespace: Registrations.DATA_EXPLORER_ADMINISTRATION_SOLUTION,
    },
    Rpa: {
        def: require("./solutions/rpa"),
        namespace: Registrations.RPA_SOLUTION,
    },
    Topology: {
        def: require("./solutions/topology"),
        namespace: Registrations.TOPOLOGY_SOLUTION,
    },
    VersionControl: {
        def: require("./solutions/administration/VersionControl"),
        namespace: Registrations.VERSION_CONTROL_ADMINISTRATION_SOLUTION,
    },
};
